'use client';

import { c as _c } from "react/compiler-runtime";
import * as RadixDialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { cx } from 'class-variance-authority';
import { Command } from 'cmdk';
import { forwardRef } from 'react';
import Overlay from '../../../overlay';
type CommandDialogProps = {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  position?: 'popper' | 'fixed';
  className?: string;
  shouldFilter?: boolean;
};
const CommandContainer = forwardRef<HTMLDivElement, CommandDialogProps>((t0, ref) => {
  const $ = _c(23);
  const {
    children,
    open,
    onOpenChange,
    position: t1,
    className,
    shouldFilter: t2
  } = t0;
  const position = t1 === undefined ? "fixed" : t1;
  const shouldFilter = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== onOpenChange) {
    t3 = () => onOpenChange(false);
    $[0] = onOpenChange;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleClose = t3;
  let t4;
  if ($[2] !== open) {
    t4 = <RadixDialog.Overlay asChild={true}><Overlay isVisible={open} className="z-[9999]!" /></RadixDialog.Overlay>;
    $[2] = open;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = position === "fixed" && "top-20 left-1/2 -translate-x-1/2";
  let t6;
  if ($[4] !== className || $[5] !== t5) {
    t6 = cx("fixed z-[9999] bg-primary shadow-lg rounded-lg overflow-hidden w-[600px] max-w-[calc(100vw-32px)] outline-none", t5, className);
    $[4] = className;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <VisuallyHidden><RadixDialog.Title>Command menu</RadixDialog.Title></VisuallyHidden>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== children || $[9] !== ref || $[10] !== shouldFilter) {
    t8 = <Command ref={ref} shouldFilter={shouldFilter}>{children}</Command>;
    $[8] = children;
    $[9] = ref;
    $[10] = shouldFilter;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== handleClose || $[13] !== t6 || $[14] !== t8) {
    t9 = <RadixDialog.Content className={t6} onEscapeKeyDown={handleClose} onPointerDownOutside={handleClose} aria-describedby={undefined}>{t7}{t8}</RadixDialog.Content>;
    $[12] = handleClose;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t4 || $[17] !== t9) {
    t10 = <RadixDialog.Portal>{t4}{t9}</RadixDialog.Portal>;
    $[16] = t4;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onOpenChange || $[20] !== open || $[21] !== t10) {
    t11 = <RadixDialog.Root open={open} onOpenChange={onOpenChange} modal={true}>{t10}</RadixDialog.Root>;
    $[19] = onOpenChange;
    $[20] = open;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
});
export default CommandContainer;